import React, {useEffect, useState} from "react";
import "./NewsPublicPages.css";
import {apiGetNewsArticle} from "../api/news";
import NewsContentRenderer from "../components/NewsContentRenderer";
import {buildNewsImageUrl, formatNewsDate} from "../utils";

function parseContent(contentJson) {
    try {
        return JSON.parse(contentJson);
    } catch {
        return null;
    }
}

export default function NewsArticlePage({slug, onBack}) {
    const [status, setStatus] = useState("loading");
    const [article, setArticle] = useState(null);

    useEffect(() => {
        setStatus("loading");
        apiGetNewsArticle(slug).then(data => {
            if (!data || data.error || !data.slug) {
                setStatus("not-found");
                return;
            }
            setArticle(data);
            setStatus("ok");
        });
    }, [slug]);

    if (status === "loading") {
        return (
            <div className="news-public-page">
                <div className="news-public-wrap">
                    <p className="news-public-status">Chargement…</p>
                </div>
            </div>
        );
    }

    if (status === "not-found") {
        return (
            <div className="news-public-page">
                <div className="news-public-wrap">
                    {onBack && (
                        <button className="news-public-btn-back" onClick={onBack}>← Toutes les actualités</button>
                    )}
                    <h1 className="news-public-title">Actualité introuvable</h1>
                    <p className="news-public-status">
                        Cette actualité n'existe pas, n'est plus publiée, ou a été retirée.
                    </p>
                </div>
            </div>
        );
    }

    const imageUrl = buildNewsImageUrl(article.cover_image_url);
    const document = parseContent(article.content_json);

    return (
        <div className="news-public-page">
            <div className="news-public-wrap news-article-wrap">
                {onBack && (
                    <button className="news-public-btn-back" onClick={onBack}>← Toutes les actualités</button>
                )}

                {article.category && <span className="news-article-category">{article.category}</span>}
                <h1 className="news-public-title">{article.title}</h1>
                <p className="news-article-date">{formatNewsDate(article.published_at)}</p>

                {imageUrl && (
                    <img className="news-article-cover" src={imageUrl} alt={article.cover_image_alt || ""}/>
                )}

                <NewsContentRenderer document={document}/>

                {article.external_url && article.external_link_label && (
                    <a
                        className="news-article-external-btn"
                        href={article.external_url}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {article.external_link_label}
                    </a>
                )}
            </div>
        </div>
    );
}
